<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							General Ledger Journal Inquiry
						</h4>
						<p class="card-category text-right d-flex align-items-center justify-content-end">
							General Ledger Journal Inquiry
							<button mat-raised-button 
									color="warn" 
									class="ml-3" 
									(click)="repostGl()" 
									[disabled]="reposting"
									title="Repost General Ledger">
								<mat-icon *ngIf="!reposting">refresh</mat-icon>
								<svg *ngIf="reposting" class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
									<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
								</svg>
								{{ reposting ? 'Reposting...' : 'Repost GL' }}
							</button>
						</p>
					</div>
					<div class="card-body">

						<form [formGroup]="journalForm" (ngSubmit)="searchJournals()">
							<div class="row align-items-center g-2">
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Journal Number From</mat-label>
										<input matInput formControlName="numberFrom" type="number" />
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Journal Number To</mat-label>
										<input matInput formControlName="numberTo" type="number" />
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>From Date</mat-label>
										<input matInput [matDatepicker]="fromDate" formControlName="fromDate" />
										<mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
										<mat-datepicker #fromDate></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-3">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>To Date</mat-label>
										<input matInput [matDatepicker]="toDate" formControlName="toDate" />
										<mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
										<mat-datepicker #toDate></mat-datepicker>
									</mat-form-field>
								</div>
								<div class="col-md-2">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Posted</mat-label>
										<mat-select formControlName="posted">
											<mat-option *ngFor="let option of postedOptions" [value]="option.value">
												{{ option.label }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-2 text-end">
									<button mat-raised-button color="accent" type="submit" class="w-100">Search</button>
								</div>
							</div>
						</form>



						<div class="col-md-12 text-center" *ngIf="isrunning">
							<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
								<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
								</circle>
							</svg>
						</div>

						<div *ngIf="journalData?.data?.length > 0">
							<!-- Search Bar -->
							<div class="mb-3">
								<input type="text" class="form-control" placeholder="Search Journals..." [(ngModel)]="searchQuery" (ngModelChange)="filterJournals()" />
							</div>

							<!-- Filtered Journals -->
							<div *ngFor="let journal of filteredJournals" class="card mb-3">
								<div class="card-header">
									<h5 class="mb-0">Journal Number: {{ journal.journalNumber }}</h5>
									<small class="text-muted">Date: {{ journal.date | date }}</small>
									<div class="export-buttons float-right">
										<button mat-raised-button color="primary" class="mr-2" (click)="loadReversal(journal)" title="Load reversal into Journal Entry">
											<mat-icon>swap_horiz</mat-icon> Reversal
										</button>
										<button mat-raised-button class="mr-2" (click)="openAttachments(journal)" title="Attachments" *ngIf="(journal.attachmentCount || 0) > 0">
											<mat-icon>attach_file</mat-icon> Attachments
										</button>
										<button mat-raised-button class="btn btn-danger" (click)="exportPdf(journal.journalNumber)">
											<i class="fa fa-file-pdf-o"></i>
										</button>
										<button mat-raised-button class="btn btn-success" (click)="exportXls(journal.journalNumber)">
											<i class="fa fa-file-excel-o"></i>
										</button>
									</div>
								</div>
								<div class="card-body">
									<div class="table-responsive" #journalTable [id]="'journalTable' + journal.journalNumber">
										<table class="table table-striped table-hover table-bordered">
											<thead class="thead-dark">
												<tr>
													<th>Account Code</th>
													<th>Account Name</th>
													<th>Description</th>
													<th>Department</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let transaction of journal.transactions">
													<td>{{ transaction.accountCode }}</td>
													<td>{{ transaction.accountName }}</td>
													<td>{{ transaction.description }}</td>
													<td>{{ transaction.tagdescription || '—' }}</td>
													<td [class.text-danger]="transaction.amount < 0" [class.text-success]="transaction.amount >= 0">
														{{ transaction.amount | currency }}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="journalData?.data?.length === 0">
							<h4 class="text-center"> No Results </h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="attachments-modal-backdrop" *ngIf="attachmentsJournal" (click)="closeAttachments()"></div>
<div class="attachments-modal panel panel-default" *ngIf="attachmentsJournal">
	<div class="panel-heading d-flex align-items-center justify-content-between">
		<h5 class="mb-0">{{ selectedAttachment ? selectedAttachment.filename : 'Attachments — Journal #' + (attachmentsJournal?.journalNumber) }}</h5>
		<button mat-icon-button (click)="closeAttachments()"><mat-icon>close</mat-icon></button>
	</div>
	<div class="panel-body">
		<ng-container *ngIf="selectedAttachment">
			<button type="button" class="btn btn-sm btn-outline-secondary mb-2" (click)="clearAttachmentView()">
				<mat-icon class="align-middle" style="font-size: 18px; width: 18px; height: 18px;">arrow_back</mat-icon> Back to list
			</button>
			<div class="journal-attachment-viewer border rounded p-2 bg-light">
				<ng-container *ngIf="isPdf(selectedAttachment)">
					<iframe [src]="selectedAttachmentSafeUrl" class="journal-attachment-iframe" [attr.title]="selectedAttachment.filename"></iframe>
				</ng-container>
				<ng-container *ngIf="isImage(selectedAttachment)">
					<img [src]="getAttachmentViewUrl(selectedAttachment)" [alt]="selectedAttachment.filename" class="journal-attachment-img img-fluid" />
				</ng-container>
				<ng-container *ngIf="!isPdf(selectedAttachment) && !isImage(selectedAttachment)">
					<p class="text-muted mb-2">Preview not available for this file type.</p>
					<a [href]="getAttachmentDownloadUrl(selectedAttachment)" target="_blank" rel="noopener noreferrer" class="btn btn-primary" [attr.download]="selectedAttachment.filename">Download {{ selectedAttachment.filename }}</a>
				</ng-container>
			</div>
		</ng-container>
		<ng-container *ngIf="!selectedAttachment">
			<div *ngIf="attachmentsLoading" class="text-center p-3">Loading…</div>
			<div *ngIf="!attachmentsLoading && journalAttachmentsList.length === 0" class="text-muted p-3">No attachments.</div>
			<ul class="list-group list-group-flush" *ngIf="!attachmentsLoading && journalAttachmentsList.length">
				<li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let a of journalAttachmentsList">
					<span>{{ a.filename }}</span>
					<div class="d-flex align-items-center gap-2">
						<span class="small text-muted" *ngIf="a.created">{{ a.created }}</span>
						<button type="button" class="btn btn-sm btn-outline-primary me-1" *ngIf="isPdf(a) || isImage(a)" (click)="viewAttachment(a)">View</button>
						<a [href]="getAttachmentDownloadUrl(a)" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-secondary" [attr.download]="a.filename">Download</a>
					</div>
				</li>
			</ul>
		</ng-container>
	</div>
</div>